module.exports = __webpack_public_path__ + "img/food_09.cb487914.jpg";